import { render } from "./julyvegas.vue?vue&type=template&id=74b5d397"
import script from "./julyvegas.vue?vue&type=script&lang=js"
export * from "./julyvegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__